import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { StorageService, AlertService } from './../services/index'
@Injectable({
  providedIn: 'root'
})
export class PermsGuard implements CanActivate {
  constructor(
    private storageService: StorageService,
    private alertService: AlertService
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('PermsGuard');
    // ruta a la que se está tratando de acceder por medio de URL
    let activeRoute: string = next.url[1].path;
    // nombre del permiso requerido para ingresar a dicha ruta
    let requiredPerm: string;
    switch (activeRoute) {
      // busqueda documentos
      case 'bplog': {
        requiredPerm = 'MISIntMor_BpLog';
        break;
      }
      case 'companylog': {
        requiredPerm = 'MISIntMor_CompanyLog';
        break;
      }
      case 'supplierlog': {
        requiredPerm = 'MISIntMor_SupplierLog';
        break;
      }
      // configuracion
      case 'Alert': {
        requiredPerm = 'MISIntMor_Alert';
        break;
      }
      case 'Company': {
        requiredPerm = 'MISIntMor_Company';
        break;
      }
      case 'AssingAlertToCompany': {
        requiredPerm = 'MISIntMor_AssignAlert';
        break;
      }
      case 'Manager': {
        requiredPerm = 'MISIntMor_Manager';
        break;
      }
      case 'ManagerByCompany': {
        requiredPerm = 'MISIntMor_ManagerByCompany';
        break;
      }
    }

    let result: boolean = false;
    if (this.storageService.getPerms()) {
      let hasPerm: any[] = [];
      // verificamos si en la lista de permisos del usuario se encuentra el permiso requerido
      let permsUser = this.storageService.getPerms();
      hasPerm = permsUser.filter((x) => {
        return (x === requiredPerm || x === 'MISIntMor_SuperUser');
      });
      result = hasPerm.length > 0 ? true : false;
    }

    // si result es falso, no tiene los permisos necesarios
    if (!result) {
      this.alertService.warningInfoAlert("No cuenta con permisos para acceder");
    }
    return result;
  }

}
